import { configureStore } from '@reduxjs/toolkit'
import approverStatusChangeReducer from './slices/Approver/approverStatusChangeSlice'
import employeeInfoReducer from './slices/Requestor/employeeInfoSlice'
import otherReqDetailsReducer from './slices/Requestor/createNewRequestSlice'
import timeOffDetailsReducer from './slices/Requestor/timeOffDetailsSlice'
import calendarViewReducer from './slices/Requestor/calendarViewSlice'
import resubmitReducer from './slices/Requestor/resubmitSlice'
import profileReducer from './slices/profileSlice'
import requestorProxyReducer from './slices/admin/requestorProxySlice'
import approverProxyReducer from './slices/admin/approverProxySlice'
import floatEmployeeReducer from './slices/admin/floatEmployeeSlice'
import manualTimeOffReducer from './slices/admin/manualTimeOffSlice'
import manualTimeOffProfileReducer from './slices/admin/manualTimeOffProfileSlice'
import approverFilterOptionsReducer from './slices/Approver/approverFilterOptionsSlice'
import approverRequestsReducer from './slices/Approver/approverRequestsSlice'
import approverHistoryReducer from './slices/Approver/approverHistorySlice'
import approverRequestDetailsReducer from './slices/Approver/approverRequestDetailsSlice'
import approverCalendarViewReducer from './slices/Approver/approverCalendarViewSlice'
import approverExportReducer from './slices/Approver/approverExportSlice'
import approverAppliedFiltersReducer from './slices/Approver/approverAppliedFiltersSlice'
import requestorTabReducer from './slices/Requestor/requestorTabSlice'
import requestorTabCountReducer from './slices/Requestor/requestorTabCountSlice'
import requestorExportReducer from './slices/Requestor/requestorExportSlice'
export const store = configureStore({
  reducer: {
    profile: profileReducer,
    employeeInfo: employeeInfoReducer,
    otherReqDetails: otherReqDetailsReducer,
    timeOffDetails: timeOffDetailsReducer,
    calendarView: calendarViewReducer,
    resubmit: resubmitReducer,
    requestorExport: requestorExportReducer,
    requestorProxy: requestorProxyReducer,
    approverProxy: approverProxyReducer,
    floatEmployee: floatEmployeeReducer,
    manualTimeOff: manualTimeOffReducer,
    approverFilterOptions: approverFilterOptionsReducer,
    approverAppliedFilters: approverAppliedFiltersReducer,
    approverRequests: approverRequestsReducer,
    approverHistory: approverHistoryReducer,
    approverRequestDetails: approverRequestDetailsReducer,
    approverCalendarView:approverCalendarViewReducer,
    approverExport: approverExportReducer,
    requestorTab: requestorTabReducer,
    requestorTabCount: requestorTabCountReducer,
    approverStatusChange: approverStatusChangeReducer,
    manualTimeOffProfile: manualTimeOffProfileReducer
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
